import { render } from "./ProductListVue.vue?vue&type=template&id=74d3493a&scoped=true"
import script from "./ProductListVue.vue?vue&type=script&lang=js"
export * from "./ProductListVue.vue?vue&type=script&lang=js"

import "./ProductListVue.vue?vue&type=style&index=0&id=74d3493a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d3493a"]])

export default __exports__